module.exports = __webpack_public_path__ + "static/media/81VP7IGGLbL._AC_UX679_.354f83ef.jpg";